/* Always-visible mobile sticky ATC bar. See snippets/sticky-mobile-atc.liquid.
   Syncs the current variant id from the main product form by polling its
   hidden/select `[name="id"]` input - the compiled theme bundle updates that
   value on swatch/option change but doesn't dispatch a documented event we
   can hook, so a light poll is the robust option here. */
(function () {
  var POLL_MS = 400;

  function getMainVariantInput() {
    return document.querySelector(
      'form[action^="/cart/add"] input[name="id"], form[action^="/cart/add"] select[name="id"]'
    );
  }

  class StickyMobileAtc extends HTMLElement {}

  function init(root) {
    var variantInput = root.querySelector('[data-sticky-mobile-variant-id]');
    var submitBtn = root.querySelector('[data-sticky-mobile-atc-submit]');
    var form = root.querySelector('form');

    if (!variantInput || !form) return;

    var lastKnownVariantId = variantInput.value;
    var mainInput = getMainVariantInput();

    if (mainInput) {
      setInterval(function () {
        if (mainInput.value && mainInput.value !== lastKnownVariantId) {
          lastKnownVariantId = mainInput.value;
          variantInput.value = lastKnownVariantId;
        }
      }, POLL_MS);
    }

    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter !== submitBtn) return; // let the dynamic checkout button submit natively
      event.preventDefault();
      if (submitBtn.hasAttribute('disabled') || submitBtn.getAttribute('aria-disabled') === 'true') return;

      submitBtn.setAttribute('disabled', 'disabled');
      var spinner = submitBtn.querySelector('.t4s-loading__spinner');
      if (spinner) spinner.hidden = false;

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:update:count'));

          // Mirror the main product form's "after add" behavior (theme
          // setting: Cart > Action when an item is added) - this bar is the
          // only visible Add to Cart control on mobile (main form's is
          // hidden there), so it needs the same redirect the desktop form
          // already does, or "go to cart"/"go to checkout" silently no-ops
          // on mobile.
          var after = window.T4Sconfigs && T4Sconfigs.afterActionATC;
          if (after === '4') {
            window.location.href = (window.T4Sroutes && T4Sroutes.cart_url) || '/cart';
          } else if (after === '5') {
            window.location.href = '/checkout';
          }
        })
        .catch(function () {})
        .finally(function () {
          submitBtn.removeAttribute('disabled');
          if (spinner) spinner.hidden = true;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-sticky-mobile-atc]');
    if (root) init(root);
  });
  if (document.readyState !== 'loading') {
    var root = document.querySelector('[data-sticky-mobile-atc]');
    if (root) init(root);
  }
})();
